(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('EditorStructureComponentDeleteController', EditorStructureComponentDeleteController);

    EditorStructureComponentDeleteController.$inject = ['$scope', '$uibModalInstance', 'name'];

    function EditorStructureComponentDeleteController($scope, $uibModalInstance, name) {
        var vm = this;

        vm.name = name;

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.confirm = function () {
            $uibModalInstance.close();
        };
    }
})();
